import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Button, Col, Label, Row, Input, Modal, ModalBody, ModalHeader, ModalFooter } from 'reactstrap';

const initialState = {
    email: '',
    oldPassword: '',
    password: '',
    confirmedPassword: '',
    firstName: '',
    lastName: '',
    passwordInvalid: false,
    confirmedPasswordInvalid: false,
    invalid: false
};


class PasswordChangeModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = initialState;
    }

    handleChange = (e) => this.setState({ [e.target.name]: e.target.value }, () => {
        const { confirmedPassword, password } = this.state;
        const confirmedPasswordInvalid = confirmedPassword.length > 0 && password !== confirmedPassword;
        this.setState({ confirmedPasswordInvalid });
    });

    handleSave = () => {
        const invalid = this.state.confirmedPasswordInvalid || this.state.password.length === 0 || this.state.confirmedPassword.length === 0
        if (!invalid) {

            if (this.props.showEmail) {
                const deconstructObject = {
                    email: this.state.email,
                    oldPassword: this.state.oldPassword,
                    password: this.state.password,
                    confirmedPassword: this.state.confirmedPassword,
                    passwordInvalid: this.state.passwordInvalid,
                    confirmedPasswordInvalid: this.state.confirmedPasswordInvalid,
                    invalid: this.state.invalid
                }
                this.props.onSave(deconstructObject, this.state.firstName, this.state.lastName);
            }
            else
                this.props.onSave(this.state.password);

            this.setState(initialState);
        }

        this.setState({ invalid });
    }

    handleToggle = () => {
        this.setState(initialState);
        this.props.onToggle();
    }

    getAlerts = () => {
        const alerts = [];
        const { invalid, oldPassword, password, confirmedPassword, confirmedPasswordInvalid } = this.state;

        if (invalid) {
            if (oldPassword.length === 0 && this.props.requireOldPassword)
                alerts.push(<Alert key='oldPasswordRequired' color="danger">Old password is required.</Alert>);
            if (password.length === 0)
                alerts.push(<Alert key='passwordRequired' color="danger">Password is required.</Alert>);
            if (confirmedPassword.length === 0)
                alerts.push(<Alert key='confirmedPasswordRequired' color="danger">Confirmed password is required.</Alert>);
            if (confirmedPasswordInvalid)
                alerts.push(<Alert key='passwordsDontMatch' color="danger">Password and confirmed password do not match.</Alert>);
        }

        this.props.validationMessages.forEach((message, index) => {
            alerts.push(<Alert key={`pv_${index}`} color="danger">{message}</Alert>);
        });

        return alerts;
    }

    render() {
        const disableSaveUser =
            this.props.fromSecurityTab !== true &&
            (this.state.firstName === '' || this.state.lastName === '');

        return (
            <React.Fragment>
                <Modal isOpen={this.props.showModal} toggle={this.handleToggle}>
                    <ModalHeader>{this.props.title || 'Change Password'}</ModalHeader>
                    <ModalBody>
                        {this.getAlerts()}
                        {this.props.requireOldPassword && <Row>
                            <Col>
                                <Label>Old Password:</Label>
                                <Input
                                    type='password'
                                    name='oldPassword'
                                    onChange={this.handleChange}
                                    value={this.state.oldPassword}
                                    invalid={this.state.oldPassword.length === 0}
                                />
                            </Col>
                        </Row>}
                        {this.props.showEmail &&
                            <Row>
                                <Col>
                                    <Label>Email:</Label>
                                    <Input
                                        type='email'
                                        name='email'
                                        onChange={this.handleChange}
                                        value={this.state.email}
                                    />
                                </Col>
                            </Row>}
                        <Row>
                            <Col>
                                <Label>Password:</Label>
                                <Input
                                    type='password'
                                    name='password'
                                    onChange={this.handleChange}
                                    value={this.state.password}
                                    invalid={this.state.password.length === 0 || this.state.passwordInvalid}
                                    required
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Label>Confirmed Password:</Label>
                                <Input
                                    type='password'
                                    name='confirmedPassword'
                                    onChange={this.handleChange}
                                    value={this.state.confirmedPassword}
                                    invalid={this.state.confirmedPassword.length === 0 || this.state.confirmedPasswordInvalid}
                                    required
                                />
                            </Col>
                        </Row>
                        { this.props.fromSecurityTab !== true &&
                        <>
                            <Row>
                                <Col>
                                    <Label>First Name :</Label>
                                    <Input
                                        type='text'
                                        name='firstName'
                                        onChange={this.handleChange}
                                        value={this.state.firstName}
                                        invalid={this.state.firstName === ''}
                                        required
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Label>Last Name:</Label>
                                    <Input
                                        type='text'
                                        name='lastName'
                                        onChange={this.handleChange}
                                        value={this.state.lastName}
                                        invalid={this.state.lastName === ''}
                                        required
                                    />
                                </Col>
                            </Row>
                         </>
                        }
                    </ModalBody>
                    <ModalFooter>
                        <Button disabled={disableSaveUser} onClick={this.handleSave}>Save</Button>
                        <Button color="primary" onClick={this.handleToggle}>Cancel</Button>
                    </ModalFooter>
                </Modal>

            </React.Fragment >
        );
    }
}

PasswordChangeModal.propTypes = {
    title: PropTypes.string,
    showEmail: PropTypes.bool,
    requireOldPassword: PropTypes.bool,
    onToggle: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    validationMessages: PropTypes.array,
    showModal: PropTypes.bool.isRequired
}

export default PasswordChangeModal